import { setHoverDeleteButton } from '@databases/redux/cellSelections/actions';
import { appStore } from '@databases/redux/store';

/**
 * Handles the mouse leave event for the delete button in the contextual menu.
 */
export function onMouseLeaveDeleteButton() {
  appStore.dispatch(setHoverDeleteButton({ value: null }));
}
